(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/betslip-matchlist.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/betslip-matchlist.js'); 
(function(Backbone, _, svs) {
  svs.tipset.views.BetslipMatchlist = Backbone.Marionette.CollectionView.extend(
    {
      className: 'panel-body betslip-coupon-body',
      tagName: 'div',
      childView: svs.tipset.views.BetslipMatch,

      initialize: function(params) {
        this.options = params;
      }
    }
  );
})(Backbone, _, svs);

 })(window);